import { state } from './message.state.js';
import { getters } from './message.getters.js';
import { actions } from './message.actions.js';
import { mutations } from './message.mutations.js';

export default {
  state,
  getters,
  actions,
  mutations
};
